import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceComponent, debounce} from "dce-engine";
import {findFragmentParent, Fragment} from "dce-fragments";
import Dce from "dce-engine/lib/decorators/Dce";
import choices from "choices.js/public/types/src/scripts/reducers/choices";
import Choices from "choices.js";
import {Choice} from "choices.js/src/scripts/interfaces/choice";

interface SelectChoicesProps {
}

/**
 * Komponent do
 * https://github.com/Choices-js/Choices
 */
@Dce("SelectChoices")
export default class SelectChoices extends DceComponent<SelectChoicesProps> {

    private choices: Choices;

    private optionsObserver: MutationObserver;

    constructor(elem: DceHTMLElement, props: SelectChoicesProps) {
        super(elem, props);

        // @ts-ignore
        import(/* webpackChunkName: "choices-css" */ 'choices.js/public/assets/styles/choices.min.css');

        this.choices = new Choices(elem, {

        });

        this.optionsObserver = new MutationObserver((mutations, observer) => {
            //this.choices.destroy();

            console.log("SSSS MUTATION ", mutations);

            this.choices.init();
            //this.choices = new Choices(elem, {});
        });

        this.optionsObserver.observe(this.elem, {
            childList: true,
            attributes: false,
            subtree: true
        });


    }
}